export default "__VITE_ASSET__DmE5ZdKx__"